module.exports = __webpack_public_path__ + "static/media/consigmentact.ff9b56bb.svg";